module.exports = __webpack_public_path__ + "static/Andrew_Hope_headshot_lores-92c57539f5084617fb311d2de16065d3.png";